export const PLAY_NOTIFICATION = 'play';
export const PAUSE_NOTIFICATION = 'pause';
export const STOP_NOTIFICATION = 'stop';

export const AD_REQUESTED = 'ad_requested';
export const AD_NOT_REQUESTED = 'ad_not_requested';
